import React from "react";
import { Progress } from "reactstrap";
import { components } from "react-select";
import { makeRequestAuth } from "../../../utils/globals";
import { datas } from "./Counrty";
import debounce from "lodash/debounce";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import axios from "axios";
import { PLUM_ROUTES } from "../../../constants/AppConstant";
import { WarningFilled } from "../../../components/Icons";
import {
  Button,
  Checkbox,
  CircularLoader,
  Dropdown,
  Input,
  Icon,
  Tooltip,
} from "@plum-xoxo/admin-dsm";
const { Option } = components;
import { XoxodayLongLogo } from "../../../components/Icons";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";
import { CustomDropDownHover } from "../../Accounts/PlatformPreferences/Component/styled";
import config from "config";

const storesUrl = `${config.storeFrontURL}`

const StyledProgress = styled(Progress).attrs()`
  .progress-bar {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    clip-path: none;
  }
`;

const HeadingTypography = styled(Typography.H1).attrs()`
  color: ${(props) => props.theme.palette.dark.c300};
`;
const SubHeadingTypography = styled(Typography).attrs()`
  color: ${(props) => props.theme.palette.dark.c200};
`;
const InputWrapper = styled(Input).attrs()`
  width: 53%;
  height: 46px;
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.dark.c000};
  border-radius: 0 8px 8px 0;
  > div {
    border: 0;
  }
`;

const CheckboxStyledTypography = styled(Checkbox).attrs()`
  .eui-checkbox-icon {
    border-color: ${(props) => props.theme.palette.dark.c200};
  }
  .eui-checkbox-box {
    padding-left: 10px;
  }
`;

const LabelTypography = styled.label`
  color: ${(props) => props.theme.palette.dark.c300};
  font-size: 12px;
  margin-bottom: 4px;
`;
const SubHeadingDark = styled.div`
  color: #252a31;
  font-size: 14px;
  width: 438px;
  margin: 0 auto;
`;
// 252A31 not available in theme
const SubText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${(props) => props.theme.palette.dark.c200};
`;
const SubTextDark = styled.span`
  color: ${(props) => props.theme.palette.dark.c300};
`;

const HeaderDiv = styled.hr`
  border-bottom: 1px solid;
  border-top: 0;
  border-color: ${(props) => props.theme.palette.dark.c200};
  opacity: 0.2;
`;
const SetUpText = styled.span`
  color: ${(props) => props.theme.palette.dark.c300};
  font-size: 14px;
`;

const CustomInputPrefix = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.light.c100};
  color: ${(props) => props.theme.palette.dark.c100};
  border: 1px solid ${(props) => props.theme.palette.dark.c000};
  border-radius: 8px 0px 0px 8px;
`;

const IconOption = (data) => {
  return (
    <Option {...data} className="d-inline-block custom-hover">
      <Typography.ButtonText color="dark" shade="c300">
        {data.data.label}
      </Typography.ButtonText>
      <Typography.HelperText color="dark" shade="c200" className="m-0 mt-4">
        {data.data.name}
      </Typography.HelperText>
    </Option>
  );
};

class ThirdStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      domain_exist: null,
      checked_flow: false,
      width: 0,
      showLoader: false,
      rewardingValue: {},
      countryValue: {},
      subDomain: "",
      error: {},
      country_id: 101, // India,
      currencyCodeList: [],
      company_id: "",
      domain_loader: false,
      showInvalidUrlError: false,
      invalidErrMsg:
        "Invalid! Store URL can be alphanumeric with no space and hyphen only.",
      isKarmaResponseSuccess: false,
      showInvalidUsecaseError: false,
      rewardUsecase: "",
      showOtherRewardUsecase: false,
      invalidUsecaseErrMsg: "",
    };
  }

  componentDidMount() {
    this.getRewardType();
    this.getGeoInfo();

    const currencyCodeList = datas
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      .map(function (item) {
        return {
          country_name: item.name,
          value: item.name + item.code,
          currencyValue: item.code,
          currency_id: item.currency_id,
          label: (
            <Typography
              component="div"
              className="d-flex m-0 p-0 mb-0 justify-content-start align-items-center"
            >
              <Typography color="dark" shade="c300" className="m-0 p-0">
                {item.emoji}{" "}
              </Typography>
              <Typography color="dark" shade="c300" className="m-0 pl-8 pr-4">
                {item.name}{" "}
              </Typography>
              <Typography color="dark" shade="c300" className="m-0 p-0">
                - {item.code}
              </Typography>
            </Typography>
          ),
          emoji: item.emoji,
        };
      });

    this.setState({
      currencyCodeList: currencyCodeList,
    });
  }

  componentWillUnmount() {
    if (this.timing) clearInterval(this.timing);
    if (this.timer) clearInterval(this.timer);
    this.setState({ isKarmaResponseSuccess: false });
  }

  timing;
  timer;

  startPolling = (company_id, email) => {
    let timeInitatie = Date.now();
    this.timing = setInterval(() => {
      if (Date.now() - timeInitatie < 15 * 60 * 1000) {
        this.getKarmaCompany(company_id, email);
      } else clearInterval(this.timing);
    }, 500);
  };

  getKarmaCompany = (company_id, email) => {
    const query = "diy.query.get_clientable_karma_company";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        company_id,
        email,
      },
    };
    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.getKarmaClientableCompany
        ) {
          if (response.data.getKarmaClientableCompany.success == 1) {
            this.setState({ isKarmaResponseSuccess: true });
            clearInterval(this.timing);
          }
        }
      }.bind(this),
      {},
      "/api/public/graph"
    );
  };

  getRewardType = () => {
    const query = "diy.query.get_plum_reward_types";
    const request_data = {
      query,
      tag: "diy",
      variables: {},
    };

    makeRequestAuth(
      request_data,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.getPlumRewardTypes &&
          response.data.getPlumRewardTypes.success == 1
        ) {
          let groups_list = response.data.getPlumRewardTypes.reward_types;
          groups_list = groups_list.map((item) => {
            let obj = {};
            obj.plum_module_id = item.plum_module_id;
            obj.name = item.help_text;
            obj.label = item.name;
            obj.show = item.show;
            obj.value = item.reward_usecase_id;
            return obj;
          });
          this.setState({ data: groups_list });
        } else {
          /* empty */
        }
      }.bind(this),
      {},
      "/api/public/graph"
    );
  };

  resumeTimeLog = () => {
    let progressWidth = 61;
    this.timeLog = setInterval(() => {
      if (progressWidth <= 100) {
        if (this.state.isKarmaResponseSuccess) {
          progressWidth = 100;
          this.setState({ width: progressWidth });
        }
        if (progressWidth === 90 && !this.state.isKarmaResponseSuccess) {
          this.setState({ width: 91 });
          clearInterval(this.timeLog);
        } else {
          progressWidth++;
          this.setState({ width: progressWidth });
        }
      } else {
        window.location.reload();
        clearInterval(this.timeLog);
      }
    }, 1800);
  };

  progressValue() {
    let progressWidth = 0;
    this.timer = setInterval(() => {
      if (progressWidth <= 100) {
        if (progressWidth === 60 && !this.state.isKarmaResponseSuccess) {
          this.setState({ width: 61, currentTimeSpent: 9 });
          clearInterval(this.timer);
          //resume time from 6 sec to 60 sec for checking response.
          this.resumeTimeLog();
        } else {
          this.setState({ width: progressWidth });
          progressWidth += 2;
        }
      } else {
        window.location.reload();
        clearInterval(this.timer);
      }
    }, 200);
  }

  settingUpProgress = () => {
    const { width, isKarmaResponseSuccess } = this.state;
    let setupText = "Your reward engine is being setup";

    if (width >= 0 && width <= 30) {
      setupText = "Your reward engine is being setup";
    } else if (width > 30 && width <= 60) {
      setupText = "Getting the gifting catalogue ready for you";
    } else if (width > 60 && width <= 90) {
      setupText = "Finishing up your account setup and getting ready";
    } else if (width >= 91) {
      if (!isKarmaResponseSuccess) {
        setupText =
          "Looks like it is taking some time! Once your account is created we will update you.";
      } else {
        setupText = "Finishing up your account setup and getting ready";
      }
    }
    return (
      <div>
        <HeadingTypography className="mb-3 text-center">
          Setting Up Your Account
        </HeadingTypography>
        <SubHeadingDark className="mb-5 text-center">
          A powerful all-in-one platform for rewards & business gifting is
          waiting for you on the other side.
        </SubHeadingDark>
        <div>
          <img src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1670245255/store/admin/reward-loading.svg" />
        </div>
        <div className="position-relative mt-80 d-flex align-items-center">
          <StyledProgress className="progressbar mt-0 w-100" value={width} />
          <Typography.H2 className="ml-8">{width}%</Typography.H2>
        </div>

        <div className="setupStep">
          {width > 90 && !isKarmaResponseSuccess ? (
            <span>
              <WarningFilled />
              <span className="align-middle ml-2">{setupText}</span>
            </span>
          ) : (
            <SetUpText>
              {setupText}
              <img src="/admin/img/setupLoading.gif" />
            </SetUpText>
          )}
        </div>
      </div>
    );
  };

  debounceRewardName = debounce((params) => {
    this.fetchRewardExist(params);
  }, 1000);

  fetchRewardExist = () => {
    const { subDomain } = this.state;
    this.setState({ domain_loader: true });
    let reg = /^[a-z0-9](.*[a-z0-9])?$/;
    if (reg.test(subDomain)) {
      const query = "diy.query.check_subdomain_exists";
      const request_data = {
        query,
        tag: "diy",
        variables: {
          sub_domain: subDomain,
        },
      };

      const checkIfRouteIsPresent = PLUM_ROUTES.findIndex(
        (route) => route === subDomain
      );

      if (checkIfRouteIsPresent === -1) {
        makeRequestAuth(
          request_data,
          function (response) {
            if (
              response &&
              response.data &&
              response.data.checkSubDomainExists &&
              response.data.checkSubDomainExists.success == 1
            ) {
              this.setState({
                domain_exist:
                  response.data.checkSubDomainExists.res.sub_domain &&
                  Object.keys(response.data.checkSubDomainExists.res.sub_domain).length
                    ? false
                    : true,
                domain_loader: false,
                showInvalidUrlError: false,
              });
            } else {
              this.setState({
                domain_loader: false,
                domain_exist: null,
                showInvalidUrlError: true,
                invalidErrMsg:
                  "Something went wrong. Please try again after sometime.",
              });
            }
          }.bind(this),
          {},
          "/api/public/graph"
        );
      } else {
        this.setState({
          domain_exist: false,
          domain_loader: false,
          showInvalidUrlError: false,
        });
      }
    } else if (this.state.subDomain == "") {
      this.setState({
        showInvalidUrlError: true,
        invalidErrMsg: "Please enter your store URL.",
      });
    } else {
      this.setState({
        showInvalidUrlError: true,
        invalidErrMsg:
          "Invalid! Hyphen is not allowed as a start or end character.",
      });
    }
  };

  checkedFlow = (event) => {
    this.setState({ checked_flow: event.target.checked });
  };

  handleValidate = () => {
    let validToProceed = false;
    let error = this.state.error;
    const regex = /^[a-z0-9](.*[a-z0-9])?$/;
    const reg = /^[a-zA-Z\s]*$/;
    if (Object.keys(this.state.rewardingValue).length == 0) {
      validToProceed = false;
      error["reward_value"] = "Please select a reward type";
    } else if (Object.keys(this.state.countryValue).length == 0) {
      validToProceed = false;
      error["country_value"] = "Please select a billing currency";
    } else if (this.state.subDomain == "" && this.state.rewardingValue.show) {
      validToProceed = false;
      error["subDomain"] = "Please enter your store URL";
    } else if (this.state.checked_flow == false) {
      validToProceed = false;
      error["terms"] = "Please accept the terms before proceeding";
    } else if (!regex.test(this.state.subDomain)) {
      validToProceed = false;
      this.setState({
        showInvalidUrlError: true,
        invalidErrMsg:
          "Invalid! Hyphen is not allowed as a start or end character.",
      });
    } else if (
      Object.keys(this.state.rewardingValue).length != 0 &&
      this.state.rewardingValue.value == 9 &&
      !this.state.rewardUsecase
    ) {
      validToProceed = false;
      this.setState({
        invalidUsecaseErrMsg:
          "The field cannot be empty, please provide a reward use-case.",
        showInvalidUsecaseError: true,
      });
    } else if (
      Object.keys(this.state.rewardingValue).length != 0 &&
      this.state.rewardingValue.value == 9 &&
      !reg.test(this.state.rewardUsecase)
    ) {
      validToProceed = false;
      this.setState({
        invalidUsecaseErrMsg:
          "Only alphabets are allowed as a reward use-case.",
        showInvalidUsecaseError: true,
      });
    } else {
      validToProceed = true;
    }
    this.setState({ error: error });
    return validToProceed;
  };

  getStatesAPI = (country_id) => {
    const data = {
      tag: "diy",
      query: "diy.query.state_query",
      variables: { country_id },
    };

    makeRequestAuth(
      data,
      (response) => {
        if (response && response.data) {
          let stateList = response.data.fetchStates.data.map(function (item) {
            return {
              value: item.state_id,
              label: item.name,
            };
          });
          let obj = stateList.find((o) => o.label === this.state.state_name);
          let objectValue = !(obj == undefined)
            ? obj.value
            : stateList[0].value;

          this.getCitiesAPI(objectValue);
          this.setState({
            stateList: stateList,
            state_id: objectValue,
            errorCountry: "",
            errorCountry_check: false,
          });
        }
      },
      {},
      "/api/public/graph"
    );
  };

  getCitiesAPI = (state_id) => {
    const data = {
      tag: "diy",
      query: "diy.query.city_query",
      variables: { state_id },
    };
    makeRequestAuth(
      data,
      (response) => {
        if (response && response.data) {
          let cityList = response?.data?.fetchCities?.data?.map(function (
            item
          ) {
            return {
              value: item.city_id,
              label: item.name,
            };
          });
          let obj = cityList?.find((o) => o.label === this.state.city_name);
          let objectValue = obj ? obj?.value : cityList?.[0]?.value;
          this.setState({
            cityList: cityList,
            city_id: objectValue,
            errorState: "",
            errorState_check: false,
          });
        }
      },
      {},
      "/api/public/graph"
    );
  };

  createPlumUser = () => {
    if (this.handleValidate()) {
      this.setState({ showLoader: true });
      const query = "diy.mutation.create_diy_plum_admin_user";
      const request_data = {
        query,
        tag: "diy",
        variables: {
          email: this.props.email,
          currency_code: this.state.countryValue.currencyValue,
          diy_uuid: this.props.diy_uuid,
          plum_module_id: this.state.rewardingValue.plum_module_id,
          company_domain: this.state.subDomain,
          country_id: this.state.country_id,
          state_id: this.state.state_id,
          city_id: this.state.city_id,
          ipaddress: "localhost",
          usecase_id: this.state.rewardingValue.value,
          address_line_1: this.state.address_line_1,
          zip_code: this.state.zip_code,
          timezone: this.state.timezone,
          custom_usecase: this.state.rewardUsecase,
          contact: this.props.phoneNumber
            ? `${this.props.isd_code_object?.phonecode}-${this.props.phoneNumber}`
            : "",
        },
      };
      makeRequestAuth(
        request_data,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.createPlumDIYUser &&
            response.data.createPlumDIYUser.success == 1
          ) {
            this.setState(
              {
                company_id: response.data.createPlumDIYUser.company_id,
                email: response.data.createPlumDIYUser.email,
                showLoader: false,
              },
              () => {
                this.startPolling(this.state.company_id, this.state.email);
                this.props.updateCurrent();
                this.progressValue();
              }
            );
          } else {
            this.setState({ showLoader: false });
            NotificationManager.error(
              response.data.createPlumDIYUser.errmsg || "Something went wrong!"
            );
          }
        }.bind(this),
        {},
        "/api/public/graph"
      );
    }
  };

  getCountriesAPI = () => {
    const data = {
      tag: "diy",
      query: "diy.query.country_query_search",
      variables: { search_term: "", limit: 5, offset: 0 },
    };

    makeRequestAuth(
      data,
      (response) => {
        if (
          response &&
          response.data &&
          response.data.fetchCountries &&
          response.data.fetchCountries.data.length > 0
        ) {
          let countryList = response.data.fetchCountries.data.map((item) => {
            return {
              value: item.country_id,
              label: item.name,
            };
          });
          let obj = countryList.find(
            (o) => o.label === this.state.country_name
          );
          let objectValue = !(obj == undefined)
            ? obj.value
            : countryList[0].value;
          this.getStatesAPI(objectValue);
          this.setState({
            countryList: countryList,
            country_id: objectValue,
            errorCountry: "",
          });
        } else {
          this.setState({ country_id: 101 });
        }
      },
      {},
      "/api/public/graph/diy"
    );
  };

  rewardedFun = (event) => {
    if (event && event.value == 13) {
      this.setState({
        rewardingValue: event,
        error: {},
        showOtherRewardUsecase: true,
      });
    } else {
      this.setState({
        rewardingValue: event,
        error: {},
        showOtherRewardUsecase: false,
      });
    }
  };

  setCountryValue = (event) => {
    this.setState({ countryValue: event, error: {} }, () => {
      this.getStatesAPI(event.currency_id);
    });
  };

  saveDomain = (name, event) => {
    const value = event.target.value;
    if (value.length === 0) {
      this.setState({ checked_flow: false });
    }
    if (value.length <= 25) {
      const { domain_exist } = this.state;
      if (!value) {
        this.setState({
          [name]: value,
          showInvalidUrlError: true,
        });
        return;
      }
      const toLower = event.target.value?.toLocaleLowerCase()?.trim();
      // ONLY ACCEPT ONE HYPHEN
      let regex = /^(?=.*[a-z0-9])(?:[a-z0-9]|-(?!-)){1,25}$/gm;
      if (!regex.test(toLower)) {
        this.setState({
          showInvalidUrlError: true,
          invalidErrMsg:
            "Invalid! Hyphen is not allowed as a start or end character.",
        });
        if ((domain_exist || !domain_exist) && domain_exist !== null) {
          setTimeout(() => {
            this.setState({ showInvalidUrlError: false });
          }, 3000);
        }
        return;
      } else {
        this.setState({
          showInvalidUrlError: true,
          invalidErrMsg: "Please enter your store URL.",
        });
      }
      this.setState(
        {
          [name]: toLower,
          error: {},
          showInvalidUrlError: false,
          domain_exist: null,
        },
        () => {
          if (toLower.length > 0) {
            this.debounceRewardName();
          }
        }
      );
    }
  };

  saveRewardUsecase = (event) => {
    const value = event.target.value.trimStart();
    const reg = /^[a-zA-Z\s]*$/;
    this.setState({
      rewardUsecase: value,
    });
    if (!reg.test(value)) {
      this.setState({
        invalidUsecaseErrMsg:
          "Only alphabets are allowed as a reward use-case.",
        showInvalidUsecaseError: true,
      });
      setTimeout(() => {
        this.setState({ showInvalidUsecaseError: false });
      }, 10000);
    } else if (!value) {
      this.setState({
        invalidUsecaseErrMsg:
          "The field cannot be empty, please provide a reward use-case.",
        showInvalidUsecaseError: true,
      });
      setTimeout(() => {
        this.setState({ showInvalidUsecaseError: false });
      }, 10000);
    }
  };

  getCurrency = () => {
    const currency_value = datas.filter(
      (item) => item.code == this.state.country_code
    );
    if (currency_value.length > 0) {
      const currencyData = {
        currencyValue: currency_value[0].code,
        country_code: currency_value[0].code,
        label: (
          <Typography component="div" className="d-flex">
            <Typography color="dark" shade="c300" className="m-0">
              {currency_value[0].emoji}{" "}
            </Typography>
            <Typography color="dark" shade="c300" className="m-0 pl-8 pr-4">
              {currency_value[0].name}{" "}
            </Typography>
            <Typography color="dark" shade="c300" className="m-0">
              - {currency_value[0].code}
            </Typography>
          </Typography>
        ),
        currency_id: currency_value[0].currency_id,
        emoji: currency_value[0].emoji,
      };
      this.setState({ countryValue: currencyData });
    }
  };

  getGeoInfo = async () => {
    await axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        const data = response.data;
        this.setState({
          currency_code: { label: data.currency, value: data.currency },
          country_name: data.country_name,
          state_name: data.region,
          city_name: data.city,
          country_code: data.currency ? data.currency : this.state.currency,
          address_line_1: data.region,
          zip_code: parseInt(data.postal),
          timezone: data.utc_offset,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.getCurrency();
    this.getCountriesAPI();
  };

  isAllMandatoryFieldsFilled = () => {
    const {
      rewardingValue,
      showOtherRewardUsecase,
      rewardUsecase,
      countryValue,
      subDomain,
    } = this.state;
    if (
      Object.keys(rewardingValue).length &&
      Object.keys(countryValue).length &&
      subDomain.length
    ) {
      if (showOtherRewardUsecase && rewardUsecase.length) {
        return true;
      } else if (!showOtherRewardUsecase) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  renderFieldsContent = () => {
    const {
      showInvalidUrlError,
      rewardingValue,
      invalidErrMsg,
      showInvalidUsecaseError,
      showOtherRewardUsecase,
      invalidUsecaseErrMsg,
    } = this.state;
    return (
      <div>
        <HeadingTypography>
          Almost there! Select rewarding details
        </HeadingTypography>
        <SubHeadingTypography className="title mb-3 pb-1">
          Just a little more info to set up your Plum account
        </SubHeadingTypography>
        <div className="setUpFields text-left">
          <form>
            <div className="mt-2">
              <div className="mb-0 form-group">
                <CustomDropDownHover>
                  <Dropdown
                    className="select-reward"
                    options={this.state.data}
                    value={
                      Object.keys(rewardingValue).length ? rewardingValue : ""
                    }
                    label="Reward Use Case"
                    required
                    onChange={this.rewardedFun}
                    isDisabled={false}
                    placeholder={"Select your use case for rewarding"}
                    noOptionsMessage={() => {
                      return "No Reward Available";
                    }}
                    components={{ Option: IconOption }}
                  />
                </CustomDropDownHover>
                {this.state.error["reward_value"] ? (
                  <div className="error">
                    {this.state.error["reward_value"]}
                  </div>
                ) : null}
              </div>
            </div>
            {showOtherRewardUsecase ? (
              <div className="mt-12">
                {/* <LabelTypography>
                  Please enter your reward usecase?
                  <span>
                    <sup>*</sup>
                  </span>
                </LabelTypography> */}
                <div className="mb-0 mt-12 form-group">
                  <Input
                    className="min-height-38"
                    type="text"
                    value={this.state.rewardUsecase}
                    onChange={(e) => this.saveRewardUsecase(e)}
                    placeholder="Enter your use case like: Referral, Loyalty, Reselling etc."
                  />
                  <div className="validationMsg">
                    {showInvalidUsecaseError ? (
                      <Typography.HelperText color={"red"} shade="200">
                        {invalidUsecaseErrMsg}
                      </Typography.HelperText>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="mt-2 mb-20 mt-20">
              <div className="mb-0 form-group">
                <CustomDropDownHover>
                  <Dropdown
                    options={this.state.currencyCodeList}
                    value={
                      Object.keys(this.state.countryValue).length > 0
                        ? this.state.countryValue
                        : ""
                    }
                    label="Rewarding Currency"
                    required
                    onChange={this.setCountryValue}
                    isDisabled={false}
                    isSearchable={true}
                    placeholder={"Select your currency"}
                    noOptionsMessage={() => {
                      return "We are not supporting this currency right now, please choose from the available list";
                    }}
                  />
                </CustomDropDownHover>
                {this.state.error["country_value"] ? (
                  <div className="error">
                    {this.state.error["country_value"]}
                  </div>
                ) : null}
              </div>
            </div>
            {Object.keys(this.state.rewardingValue).length != 0 ? (
              <>
                <div className="mt-2 mb-20">
                  <div className="mb-0 form-group">
                    <div className="input-group">
                      {/* <div className="input-group-prepend">
                        <CustomInputPrefix
                          component="span"
                          className="d-flex align-items-center px-12"
                        >
                          https://www.stores.xoxoday.com/
                        </CustomInputPrefix>
                      </div> */}
                      <Input
                        label={
                          <LabelTypography>
                            Reward Store Link <span>*</span>
                            <span className="ml-4">
                              <Tooltip
                                offset={[0, 5]}
                                tooltip={
                                  <>
                                    This will be your reward store website
                                    providing <br></br>a wide range of options
                                    including gift
                                    <br></br> vouchers, merchandise and
                                    experiences.
                                  </>
                                }
                              >
                                <Icon
                                  iconName="Help"
                                  onClick={() => {}}
                                  size="14"
                                  className="ml-0"
                                  color="dark"
                                  shade="c200"
                                  padding={0}
                                />
                              </Tooltip>
                            </span>
                          </LabelTypography>
                        }
                        className="w-100"
                        prefix={storesUrl}
                        type="text"
                        value={this.state.subDomain}
                        onChange={(e) => this.saveDomain("subDomain", e)}
                        placeholder="your-reward-store-url"
                        helperText={
                          <div className="validationMsg mb-3 mt-4">
                            {showInvalidUrlError ? (
                              <>
                                <Typography.HelperText
                                  color={"red"}
                                  shade="200"
                                >
                                  {invalidErrMsg}
                                </Typography.HelperText>
                              </>
                            ) : null}

                            {!showInvalidUrlError &&
                            !this.state.subDomain == "" &&
                            this.state.domain_exist &&
                            !this.state.domain_loader ? (
                              <>
                                <Typography.HelperText
                                  color={"green"}
                                  shade="300"
                                >
                                  &#10003; The store name is available
                                </Typography.HelperText>
                              </>
                            ) : null}

                            {!showInvalidUrlError &&
                            !this.state.domain_exist &&
                            this.state.domain_exist != null &&
                            !this.state.domain_loader ? (
                              <>
                                <Typography.HelperText
                                  color={"red"}
                                  shade="200"
                                >
                                  This store name is already taken. Please
                                  re-enter a different store name.
                                </Typography.HelperText>
                              </>
                            ) : null}
                          </div>
                        }
                        error={
                          showInvalidUrlError ||
                          (!showInvalidUrlError &&
                            !this.state.domain_exist &&
                            this.state.domain_exist != null &&
                            !this.state.domain_loader)
                        }
                      />
                    </div>
                  </div>
                  {/* <SubText>
                    It can be simple like your company name{" "}
                    <SubTextDark className="inkNormal">
                      (eg. infosys or infosysreward)
                    </SubTextDark>
                    , Then your URL will be{" "}
                    <SubTextDark className="inkNormal">
                      https://www.stores.xoxoday.com/infosysreward
                    </SubTextDark>
                  </SubText> */}
                  {this.state.error["subDomain"] && !showInvalidUrlError ? (
                    <div className="error">{this.state.error["subDomain"]}</div>
                  ) : null}
                </div>
                <div className="d-flex align-items-center mb-36">
                  <CheckboxStyledTypography
                    checked={this.state.checked_flow}
                    onChange={(e) => this.checkedFlow(e)}
                    label={
                      <Typography
                        color="dark"
                        shade="c200"
                        className="mb-0"
                        component="span"
                      >
                        I agree that currency and store link can only be set
                        once.
                      </Typography>
                    }
                  />
                  {/* <CheckboxText>
  Currency, Store URL can be set only once
  </CheckboxText> */}
                </div>
              </>
            ) : null}
          </form>

          {this.state.error["terms"] ? (
            <div className="error mb-2">{this.state.error["terms"]}</div>
          ) : null}
          <div className="btn-container">
            <Button
              size="large"
              id="diySignup-lets-start"
              className="start-rewarding"
              disabled={
                !this.state.domain_exist ||
                !this.state.checked_flow ||
                !this.isAllMandatoryFieldsFilled()
              }
              onClick={() => {
                !this.state.showLoader &&
                this.state.domain_exist &&
                this.isAllMandatoryFieldsFilled()
                  ? this.createPlumUser()
                  : null;
              }}
            >
              {this.state.showLoader ? (
                <CircularLoader />
              ) : (
                "Let’s Start Rewarding"
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="step-three">
        <Typography
          component="div"
          className="d-flex justify-content-center mt-24"
        >
          <XoxodayLongLogo width="135" height="40" />
        </Typography>
        <HeaderDiv className="mt-24 mb-36" />
        {/* <ProgressHeader currentStep={this.props.currentStep} /> */}
        {this.props.currentStep === 3 ? (
          <div className="content pt-0">{this.renderFieldsContent()}</div>
        ) : (
          <div className="content progress-content text-center">
            {this.settingUpProgress()}
          </div>
        )}
        <NotificationContainer />
      </div>
    );
  }
}

export default ThirdStep;
